export default () => ({
    filesBag: [],
    widgetState: true,
    showWidget: false,

    init() {
        window.addEventListener('upload::started', ({ detail }) => {
            this.showWidget = true;
            this.widgetState = true;
            detail.files.forEach(file => {
                const exists = this.filesBag.some(
                    f => f.componentId === detail.componentId && f.batchId === detail.batchId && f.index === file.index
                );
                if (!exists) {
                    this.filesBag.push({
                        componentId: detail.componentId,
                        batchId: detail.batchId,
                        index: file.index,
                        name: file.name,
                        humanSize: file.humanSize,
                        progress: 0,
                        completed: false,
                        abort: false,
                        error: false,
                    });
                }
            });
        });

        window.addEventListener('upload::progress', ({ detail }) => {
            const file = this.filesBag.find(
                f => f.componentId === detail.componentId && f.batchId === detail.batchId && f.index === detail.index
            );
            if (file) {
                file.progress = detail.progress;
            }
        });

        window.addEventListener('upload::completed', ({ detail }) => {
            const file = this.filesBag.find(
                f => f.componentId === detail.componentId && f.batchId === detail.batchId && f.index === detail.index
            );
            if (file) {
                file.progress = 100;
                file.completed = true;
            }
        });

        window.addEventListener('upload::failed', ({ detail }) => {
            const file = this.filesBag.find(
                f => f.componentId === detail.componentId && f.batchId === detail.batchId && f.index === detail.index
            );
            if (file) {
                file.progress = 0;
                file.error = true;
                if (detail.abort) {
                    file.abort = true;
                    file.completed = true;
                }
            }
        });
    },

    cancel(item) {
        const file = this.filesBag.find(
            f => f.componentId === item.componentId && f.batchId === item.batchId && f.index === item.index
        );
        if (file) {
            file.abort = true;
            file.error = true;
            file.completed = true;
        }
        window.dispatchEvent(new CustomEvent('upload::cancel', {
            detail: {
                componentId: item.componentId,
                batchId: item.batchId,
                index: item.index,
            }
        }));
    },

    cancelAll() {
        this.filesBag.forEach(file => {
            if (!file.completed && !file.error && !file.abort) {
                window.dispatchEvent(new CustomEvent('upload::cancel', {
                    detail: {
                        componentId: file.componentId,
                        batchId: file.batchId,
                        index: file.index,
                    }
                }));
            }
        });
        this.filesBag = [];
        this.showWidget = false;
    },
});
